import styled, { css } from 'styled-components';

const shouldForwardProp = prop =>
  !['variant', 'color', 'size', 'disabled', 'backgroundColor'].includes(prop);

const getColorStyles = color => {
  switch (color) {
    case 'primary':
      return css`
        background: var(--Primary-100);
        color: var(--Primary-800);
      `;
    case 'error':
      return css`
        background: var(--Error-500);
        color: var(--GrayScale-0);
      `;
    case 'custom':
      return css`
        background: rgba(62, 28, 150, 0.5);
        color: var(--GrayScale-0);
      `;
    default:
      return css`
        background: var(--GrayScale-800);
        color: var(--GrayScale-0);
      `;
  }
};

const getSizeStyles = size => {
  switch (size) {
    case 'small':
      return css`
        padding: 0px 4px;
      `;
    case 'medium':
      return css`
        padding: 3px 6px;
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 20px;
        border-radius: 8px;
      `;
    default:
      return css`
        padding: 0px 4px;
      `;
  }
};

const BadgeStyled = styled.div.withConfig({ shouldForwardProp })`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 2px;
  border-radius: 3px;

  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  ${props => getColorStyles(props.color)}
  ${props => getSizeStyles(props.size)}
`;

export default BadgeStyled;
